import { createSelector } from '@reduxjs/toolkit';
import qs from 'querystring';

import type { StateWithRouter } from './types';

const selectRouter = (state: StateWithRouter) => state.router;

export const selectRouterPathname = createSelector(
  [selectRouter],
  ({ location: { pathname } }) => pathname,
);

export const selectRouterQueryParameters = createSelector(
  [selectRouter],
  ({ location: { search } }) => qs.parse(search.split('?')[1]),
);
